import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { ReserveFieldOnlineMeeting } from '../../ReserveFieldOnlineMeeting/ReserveFieldOnlineMeeting';

export const ReserveFormOnlineMeeting: React.FC<{ isEdit: boolean, isMinimalistic: boolean }> = ({ isEdit, isMinimalistic }) => {
  const { form, isMeetingRoom, hasMSCalendar, hasGoogleCalendar } =
    useReserveForm();

  if (!isMeetingRoom) return null;

  return (
    <ReserveFieldOnlineMeeting
      isEdit={isEdit}
      hasMSCalendar={hasMSCalendar}
      hasGoogleCalendar={hasGoogleCalendar}
      isMeetingRoom={isMeetingRoom}
      form={form}
      isMinimalistic={isMinimalistic}
    />
  );
};
